// CRC-32/MPEG-2 (poly 0x04C11DB7, init 0xFFFFFFFF, no reflection, no final
// XOR) — the PSI section CRC.
const TABLE = (() => {
    const t = new Uint32Array(256);
    for (let i = 0; i < 256; i++) {
        let c = i << 24;
        for (let b = 0; b < 8; b++) {
            c = c & 0x80000000 ? (c << 1) ^ 0x04c11db7 : c << 1;
        }
        t[i] = c >>> 0;
    }
    return t;
})();
export function crc32Mpeg2(data) {
    let crc = 0xffffffff;
    for (let i = 0; i < data.length; i++) {
        crc = ((crc << 8) ^ TABLE[((crc >>> 24) ^ data[i]) & 0xff]) >>> 0;
    }
    return crc >>> 0;
}
//# sourceMappingURL=crc32.js.map